// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const uid: CountryValidator<"AT"> = createValidator(
  "at.uid",
  10,
);

export default uid;
export const compact = uid.compact;
export const format = uid.format;
export const validate = uid.validate;
export const generate = (): string =>
  uid.generate?.() ??
  (() => {
    throw new Error(
      "Validator at.uid cannot generate values",
    );
  })();
